import * as tslib_1 from "tslib";
import { USER_CARD_CONFIG } from "../../config/api";
import { SettingsLoaderService } from "../settingsLoader.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../loader.service";
var StatesService = /** @class */ (function (_super) {
    tslib_1.__extends(StatesService, _super);
    function StatesService(http, loaderService) {
        var _this = _super.call(this, loaderService) || this;
        _this.http = http;
        _this.loaderService = loaderService;
        _this.config = USER_CARD_CONFIG;
        return _this;
    }
    StatesService.prototype.getStatesList = function () {
        this.showLoader();
        return this.http.post(this.config.states, {});
    };
    StatesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StatesService_Factory() { return new StatesService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService)); }, token: StatesService, providedIn: "root" });
    return StatesService;
}(SettingsLoaderService));
export { StatesService };
